var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3389 19.3016C25.1155 19.3016 25.7451 18.6722 25.7451 17.8954V10.0927H70.2544V17.8954C70.2544 18.6722 70.8841 19.3016 71.6607 19.3016C72.4373 19.3016 73.0669 18.6722 73.0669 17.8954V5.15625C73.0669 2.313 70.7539 0 67.9107 0H28.0889C25.2456 0 22.9326 2.313 22.9326 5.15625V17.8954C22.9326 18.6722 23.5622 19.3016 24.3389 19.3016ZM25.7451 5.15625C25.7451 3.86381 26.7964 2.8125 28.0889 2.8125H67.9107C69.2031 2.8125 70.2544 3.86381 70.2544 5.15625V7.28025H25.7451V5.15625Z",
    fill: "url(#paint0_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9536 21.8409H5.04637C2.26388 21.8409 0 24.1046 0 26.8873V35.9327C0 37.7419 1.47206 39.2139 3.28125 39.2139H3.82219V83.3093C3.82219 86.5491 6.07725 89.2718 9.10031 89.9904V92.7188C9.10031 94.5279 10.5724 96 12.3816 96H15.9118C17.721 96 19.1931 94.5279 19.1931 92.7188V90.1757H76.4428V92.7188C76.4428 94.5279 77.9149 96 79.7241 96H83.2543C85.0635 96 86.5356 94.5279 86.5356 92.7188V90.0664C89.7398 89.4874 92.1778 86.6777 92.1778 83.3093V39.2138H92.7188C94.5279 39.2138 96 37.7417 96 35.9325V26.8871C96 24.1046 93.7361 21.8408 90.9536 21.8409ZM15.9118 93.1875H12.3816C12.1232 93.1875 11.9128 92.9773 11.9128 92.7188V90.1759H16.3806V92.7188C16.3806 92.9773 16.1702 93.1875 15.9118 93.1875ZM83.7231 92.7188C83.7231 92.9773 83.5127 93.1875 83.2543 93.1875H79.7241C79.4657 93.1875 79.2553 92.9773 79.2553 92.7188V90.1759H83.7231V92.7188ZM93.1875 35.9327C93.1875 36.1913 92.9771 36.4014 92.7188 36.4014H82.2174C81.4408 36.4014 80.8112 37.0309 80.8112 37.8077C80.8112 38.5845 81.4408 39.2139 82.2174 39.2139H89.3655V83.3093C89.3655 85.5446 87.5469 87.3632 85.3116 87.3632H85.1295H10.6886C8.45325 87.3632 6.63469 85.5446 6.63469 83.3093V39.2138H17.4726V44.9779C17.4726 47.8209 19.7856 50.1341 22.6288 50.1341H26.0492C28.8924 50.1341 31.2054 47.8209 31.2054 44.9779V37.9174C31.2054 35.0743 28.8924 32.7611 26.0492 32.7611H22.6288C20.313 32.7611 18.3489 34.2956 17.7 36.4013H3.28125C3.02288 36.4013 2.8125 36.1911 2.8125 35.9325V26.8871C2.8125 25.6554 3.81469 24.6533 5.04637 24.6533H90.9536C92.1853 24.6533 93.1875 25.6554 93.1875 26.8871V35.9327ZM20.2851 44.9781V37.9176C20.2851 36.6251 21.3364 35.5738 22.6288 35.5738H26.0492C27.3416 35.5738 28.3929 36.6251 28.3929 37.9176V44.9781C28.3929 46.2705 27.3416 47.3218 26.0492 47.3218H22.6288C21.3366 47.3218 20.2851 46.2703 20.2851 44.9781Z",
    fill: "url(#paint1_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3711 32.7614H69.9507C67.6349 32.7614 65.6708 34.2959 65.0219 36.4015H34.8955C34.1189 36.4015 33.4893 37.0309 33.4893 37.8077C33.4893 38.5845 34.1189 39.214 34.8955 39.214H64.7944V44.9781C64.7944 47.8212 67.1074 50.1343 69.9507 50.1343H73.3711C76.2143 50.1343 78.5273 47.8212 78.5273 44.9781V37.9176C78.5273 35.0744 76.2143 32.7614 73.3711 32.7614ZM75.7148 44.9781C75.7148 46.2705 74.6635 47.3218 73.3711 47.3218H69.9507C68.6583 47.3218 67.6069 46.2705 67.6069 44.9781V37.9176C67.6069 36.6252 68.6583 35.5739 69.9507 35.5739H73.3711C74.6635 35.5739 75.7148 36.6252 75.7148 37.9176V44.9781Z",
    fill: "url(#paint2_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6396 64.6127H49.4058V62.3788C49.4058 61.602 48.7761 60.9725 47.9995 60.9725C47.2229 60.9725 46.5933 61.602 46.5933 62.3788V64.6127H44.3594C43.5827 64.6127 42.9531 65.2421 42.9531 66.0189C42.9531 66.7957 43.5827 67.4252 44.3594 67.4252H46.5933V69.659C46.5933 70.4358 47.2229 71.0653 47.9995 71.0653C48.7761 71.0653 49.4058 70.4358 49.4058 69.659V67.4252H51.6396C52.4163 67.4252 53.0459 66.7957 53.0459 66.0189C53.0459 65.2421 52.4163 64.6127 51.6396 64.6127Z",
    fill: "url(#paint3_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3884 40.0416H70.5684C69.7917 40.0416 69.1621 40.6711 69.1621 41.4479C69.1621 42.2247 69.7917 42.8541 70.5684 42.8541H72.3884C73.165 42.8541 73.7947 42.2247 73.7947 41.4479C73.7947 40.6711 73.165 40.0416 72.3884 40.0416Z",
    fill: "url(#paint4_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3585 53.893C59.9074 52.3354 57.9704 51.4778 55.9041 51.4778C53.8379 51.4778 51.9008 52.3354 50.4497 53.8928L49.6352 54.7669C49.2079 55.2255 48.6274 55.4781 48.0008 55.4781C47.3742 55.4781 46.7937 55.2255 46.3664 54.7669L45.5519 53.893C44.1008 52.3354 42.1637 51.4778 40.0975 51.4778C38.0312 51.4778 36.0942 52.3354 34.6431 53.893C34.611 53.9273 34.5805 53.9637 34.552 54.0012C28.5945 61.8482 39.3089 74.0203 44.1921 78.8895C45.225 79.9197 46.5779 80.4867 48.0008 80.4867C49.4237 80.4867 50.7764 79.9195 51.8097 78.8893C56.6927 74.0205 67.407 61.8484 61.4496 54.0012C61.4209 53.9637 61.3905 53.9273 61.3585 53.893ZM49.8242 76.8977C49.3219 77.3983 48.6745 77.6742 48.001 77.6742C47.3275 77.6742 46.68 77.3983 46.1779 76.8979C39.1945 69.9345 33.0672 60.7393 36.7495 55.7588C37.6566 54.8113 38.8429 54.2903 40.0977 54.2903C41.3747 54.2903 42.5811 54.8299 43.4942 55.8102L44.3087 56.6843C45.2597 57.7048 46.6056 58.2904 48.0008 58.2904C49.396 58.2904 50.7417 57.7048 51.6929 56.6843L52.5074 55.8102C53.4205 54.8301 54.6267 54.2903 55.9039 54.2903C57.1587 54.2903 58.345 54.8113 59.2521 55.7588C62.9342 60.7392 56.8071 69.9343 49.8242 76.8977Z",
    fill: "url(#paint5_linear_2248_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0671 42.8541C25.8438 42.8541 26.4734 42.2247 26.4734 41.4479C26.4734 40.6711 25.8438 40.0416 25.0671 40.0416H23.2471C22.4704 40.0416 21.8408 40.6711 21.8408 41.4479C21.8408 42.2247 22.4704 42.8541 23.2471 42.8541H25.0671Z",
    fill: "url(#paint6_linear_2248_728)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2248_728",
    x1: 47.9998,
    y1: 0,
    x2: 47.9998,
    y2: 19.3016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2248_728",
    x1: 48,
    y1: 21.8409,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2248_728",
    x1: 56.0083,
    y1: 32.7614,
    x2: 56.0083,
    y2: 50.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2248_728",
    x1: 47.9995,
    y1: 60.9725,
    x2: 47.9995,
    y2: 71.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2248_728",
    x1: 71.4784,
    y1: 40.0416,
    x2: 71.4784,
    y2: 42.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2248_728",
    x1: 48.0008,
    y1: 51.4778,
    x2: 48.0008,
    y2: 80.4867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2248_728",
    x1: 24.1571,
    y1: 40.0416,
    x2: 24.1571,
    y2: 42.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageBlue);
export default __webpack_public_path__ + "static/media/storageBlue.ebf2847cf2b6bfe6aa41b0484bff2e0e.svg";
export { ForwardRef as ReactComponent };